// extracted by mini-css-extract-plugin
module.exports = {"titleColor":"NewsBanner_titleColor__sxRm8","dateColor":"NewsBanner_dateColor__QJVQI","linkColor":"NewsBanner_linkColor__3Fs_q","icoColor":"NewsBanner_icoColor__f0u6z"};